import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { type Props } from "@/components/sidebar/Button";
import { useStore } from "@/store";

export const HintsButton = observer(function HintsButton(props: Props<"button">) {
  const t = useTranslations("sidebar");
  const { view } = useStore();

  return (
    <Sidebar.Button
      className="rounded-8 sm:hidden"
      icon={<Icon name="Tips" />}
      title={t("hints")}
      isActive={view.isHintsPanelVisible}
      onClick={() => view.toggleHintsPanel()}
      {...props}
    />
  );
});
